<div style="height: 0;">
   <iframe id="printPDF" style="height: 0;width: 0;border: none;"></iframe>
</div>